import {capitalize} from 'lodash/string';
import request from './base';
import {excludeObjNullValue} from 'utils/common';
import {isEmpty} from 'lodash/lang';

/**
 * subscription endpoints
 */
export const fetchSubscriptions = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/subscriptions', q, page, perPage, sortOpts, extraParams);

export const fetchSubscription = (subscriptionId) => request.fetchDetail(`/subscriptions/${subscriptionId}`);

export const createSubscription = (payload) =>
  request.postJSON(
    '/subscriptions',
    excludeObjNullValue({
      origin: window.location.origin,
      email: payload.email,
      order_id: payload.order.id,
      classroom_id: payload.classroomId,
      subscription_type: payload.subscriptionType,
    }),
  );

export const createSubscriptionWithReader = (payload) =>
  request.postJSON(
    '/subscriptions',
    excludeObjNullValue({
      origin: window.location.origin,
      order_id: payload.order.id,
      classroom_id: payload.classroomId,
      email: payload.user.email,
      username: payload.user.username,
      first_name: capitalize(payload.user.firstName),
      last_name: capitalize(payload.user.lastName),
      password: payload.user.password,
    }),
    {
      with_reader: true,
    },
  );

export const updateSubscription = (payload) =>
  request.putJSON(
    `/subscriptions/${payload.subscriptionId}`,
    excludeObjNullValue({
      origin: window.location.origin,
      email: payload.email,
      expiry_date: payload.expiryDate,
      classroom_id: payload.classroomId,
    }),
  );

export const deleteSubscription = (subscriptionId) => request.deleteReq(`/subscriptions/${subscriptionId}`);

export const markSubscriptionExpired = (subscriptionId) =>
  request.putJSON(`/subscriptions/${subscriptionId}/mark-expired`);

export const resendSubscription = (subscriptionId) =>
  request.putJSON(
    `/subscriptions/${subscriptionId}/resend`,
    excludeObjNullValue({
      origin: window.location.origin,
    }),
  );

export const manuallyActivateSubscription = ({subscriptionId, reader, parent}) =>
  request.putJSON(
    `/subscriptions/${subscriptionId}/manually-activate`,
    excludeObjNullValue({
      reader: isEmpty(reader)
        ? null
        : excludeObjNullValue({
            email: reader.email,
            username: reader.username,
            first_name: capitalize(reader.firstName),
            last_name: capitalize(reader.lastName),
            password: reader.password,
          }),
      parent: isEmpty(parent)
        ? null
        : excludeObjNullValue({
            email: parent.email,
            username: parent.username,
            first_name: capitalize(parent.firstName),
            last_name: capitalize(parent.lastName),
            password: parent.password,
          }),
    }),
  );

export const validateSubscription = () => request.getJSON(`/subscription/validate${window.location.search}`);

export const activateMySubscription = (subscriptionId) =>
  request.postJSON(
    '/subscription/activate',
    excludeObjNullValue({
      subscription_id: subscriptionId,
    }),
  );

export const acceptSubscription = (subscriptionId) =>
  request.postJSON(
    '/subscription/accept',
    excludeObjNullValue({
      subscription_id: subscriptionId,
    }),
  );

export const assignSubscription = (payload) =>
  request.postJSON(
    '/subscription/assign',
    excludeObjNullValue({
      subscription_id: payload.subscriptionId,
      user_id: payload.userId,
    }),
  );

export const bulkCreateSubscription = (payload) =>
  request.postJSON(
    '/subscriptions/bulk-create',
    excludeObjNullValue({
      origin: window.location.origin,
      classroom_id: payload.classroomId,
      expiry_date: payload.expiryDate,
      users: payload.users.map((user) => ({
        email: user.email,
      })),
    }),
  );

export const fetchClassroomSubscriptions = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/subscriptions/classrooms', q, page, perPage, sortOpts, extraParams);

export const setClassroomAvailableSubscription = (payload) =>
  request.putJSON(
    `/subscriptions/classrooms/${payload.classroomId}`,
    excludeObjNullValue({
      number: payload.availableSubscriptions,
    }),
  );

export const bulkCreateStudentsToClassroom = (payload) =>
  request.postJSON(
    '/subscriptions/bulk-create-students',
    excludeObjNullValue({
      classroom_id: payload.classroomId,
      order_id: payload.orderId,
      users: payload.users.map((user) => ({
        first_name: capitalize(user.firstName),
        last_name: capitalize(user.lastName),
      })),
    }),
  );

export const directCreateSubscriptionsForReaders = (payload) =>
  request.postJSON(
    '/subscriptions/direct-create-for-current-readers',
    excludeObjNullValue({
      order_id: payload.order.id,
      classroom_id: payload.classroomId,
      user_ids: Array.from(payload.userIds),
    }),
  );

export const moveStudentsToAnotherClassroomWithReadings = (payload) =>
  request.postJSON(
    '/subscriptions/move-students-to-classroom-with-readings',
    excludeObjNullValue({
      old_classroom_id: payload.oldClassroomId,
      classroom_id: payload.classroom.id,
      user_ids: Array.from(payload.userIds),
    }),
  );
